import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqItems } from '../data/mock';

const FAQSection = () => {
  return (
    <section id="faq" className="py-16 md:py-24 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-r from-sand-100/70 to-transparent" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16 items-start">
          {/* Header */}
          <div className="lg:sticky lg:top-32">
            <p className="text-teal-600 font-medium tracking-[0.3em] uppercase text-xs mb-2">
              FAQ
            </p>
            <h2 className="text-3xl md:text-4xl font-serif text-stone-800 mb-4">
              Часто задаваемые вопросы
            </h2>
            <p className="text-stone-600 text-lg mb-8">
              Ответы на самые распространённые вопросы о консультациях и процессе терапии.
            </p>
            
            <div className="bg-sand-50 section-contrast rounded-2xl p-6">
              <h4 className="font-semibold text-stone-800 mb-2">
                Не нашли ответ?
              </h4>
              <p className="text-stone-600 text-sm mb-4">
                Свяжитесь со мной напрямую — я с удовольствием отвечу на все ваши вопросы.
              </p>
              <a
                href="#appointment"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#appointment').scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-teal-700 font-medium hover:text-teal-800 transition-colors"
              >
                Задать вопрос →
              </a>
            </div>
          </div>

          {/* FAQ Accordion */}
          <div>
            <Accordion type="single" collapsible className="space-y-4">
              {faqItems.map((item) => (
                <AccordionItem
                  key={item.id}
                  value={`item-${item.id}`}
                  className="bg-sand-100 rounded-2xl px-6 border-none"
                >
                  <AccordionTrigger className="text-left text-stone-800 font-medium py-5 hover:no-underline hover:text-teal-700 transition-colors">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-stone-600 pb-5 leading-relaxed">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
